export let Messages = {
    "offline":"You are offline. Search for places disabled.",
    "week_confirm":"Confirm the week?",
    "hr_confirm":"Only the HR operator can make changes once the week is confirmed."
};


// WEBPACK FOOTER //
// ./src/constants/messages.ts